import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// Async thunks for API calls
export const fetchCompanies = createAsyncThunk(
  'company/fetchCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch('/api/companies', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      })
      
      if (!response.ok) {
        throw new Error('Failed to fetch companies')
      }
      
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const switchCompany = createAsyncThunk(
  'company/switchCompany',
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/companies/${companyId}/switch`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      })
      
      if (!response.ok) {
        throw new Error('Failed to switch company')
      }
      
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

const initialState = {
  companies: [
    { id: 'comp1', name: 'Acme Corp India', type: 'Pvt Ltd', gstn: 'GSTIN123' },
    { id: 'comp2', name: 'Acme Corp US', type: 'LLC', gstn: 'GSTIN456' },
  ],
  currentCompany: JSON.parse(localStorage.getItem('currentCompany')) || { id: 'comp1', name: 'Acme Corp India', type: 'Pvt Ltd', gstn: 'GSTIN123' },
  isLoading: false,
  error: null,
  companySettings: {
    theme: 'light',
    currency: 'INR',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24h',
    numberFormat: 'en-IN',
  },
}

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCurrentCompany: (state, action) => {
      state.currentCompany = action.payload
      localStorage.setItem('currentCompany', JSON.stringify(action.payload))
    },
    updateCompanySettings: (state, action) => {
      state.companySettings = { ...state.companySettings, ...action.payload }
      localStorage.setItem('companySettings', JSON.stringify(state.companySettings))
    },
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Companies
      .addCase(fetchCompanies.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.isLoading = false
        state.companies = action.payload
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })
      
      // Switch Company
      .addCase(switchCompany.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(switchCompany.fulfilled, (state, action) => {
        state.isLoading = false
        state.currentCompany = action.payload
        localStorage.setItem('currentCompany', JSON.stringify(action.payload))
      })
      .addCase(switchCompany.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })
  },
})

export const { setCurrentCompany, updateCompanySettings, clearError } = companySlice.actions
export default companySlice.reducer

